import {
    AuthGate as SharedAuthGate,
    configureSession,
} from '@gagovictor/shared-admin-core';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../redux/store';
import getTheme from '../shared/config/theme';
import { resolveThemeMode } from '../shared/redux/preferencesSlice';

import { BFF_BASE_URL } from './authApi';

export { useAuth } from '@gagovictor/shared-admin-core';

configureSession('victoria-admin-token');

/**
 * Nothing behind this renders, and so nothing is fetched, until the visitor has signed in with an admin account:
 * password or Google, then the second factor. The server enforces the same rule on every request. The gate is
 * shared-admin-core's; this only gives it the app's theme and address.
 */
export const AuthGate: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const themeMode =
        useSelector((state: RootState) => state.preferences?.theme) || 'dark';
    const colorPalette = useSelector(
        (state: RootState) => state.preferences?.colorPalette
    );
    const resolvedMode = resolveThemeMode(themeMode);
    const muiTheme = useMemo(
        () => getTheme(resolvedMode, colorPalette),
        [resolvedMode, colorPalette]
    );

    return (
        <ThemeProvider theme={muiTheme}>
            <CssBaseline />
            <SharedAuthGate appName="VictorIA" apiBaseUrl={BFF_BASE_URL}>
                {() => children}
            </SharedAuthGate>
        </ThemeProvider>
    );
};
